import { DialogContentText, Grid, List, ListItem } from '@mui/material';
import { useInterviewOptions } from '@providers/InterviewsProvider';
import { AccessRole, UserCreationForm, getGroupClaimsKey } from '@synergetx/puppet-interview-types';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';

export const PermissionLevelDescription = () => {
    const { values } = useFormikContext<UserCreationForm>();
    const { selectedInterview } = useInterviewOptions();
    const groupId = selectedInterview?.groupId;

    const renderDescription = useMemo(() => {
        const currentClaims = values.claims;
        if (!groupId || currentClaims[getGroupClaimsKey(groupId)] === AccessRole.NONE)
            return (
                <>
                    <ListItem sx={{ display: 'list-item' }}>
                        removed from the survey and has no access
                    </ListItem>
                </>
            );
        if (currentClaims[getGroupClaimsKey(groupId)] === AccessRole.ADMIN) {
            return (
                <>
                    <ListItem sx={{ display: 'list-item' }}>
                        add additional group managers/project leads
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        create and manage new projects in that group
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        has all "Project lead" permissions
                    </ListItem>
                </>
            );
        } else if (currentClaims[getGroupClaimsKey(groupId)] === AccessRole.SUPERVISOR) {
            return (
                <>
                    <ListItem sx={{ display: 'list-item' }}>
                        manage surveys online in this project
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>use the survey editor</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        add or remove both assessors and project leads for the survey
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>download survey results/data</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        sign into the mobile app and assess participants
                    </ListItem>
                </>
            );
        } else if (currentClaims[getGroupClaimsKey(groupId)] === AccessRole.ASSESSOR) {
            return (
                <>
                    <ListItem sx={{ display: 'list-item' }}>
                        sign into the mobile app and assess participants
                    </ListItem>
                </>
            );
        }
    }, [groupId, values.claims]);

    return (
        <Grid
            sx={{
                flexDirection: 'column',
            }}
        >
            <DialogContentText>Permission Level Description</DialogContentText>
            <List sx={{ listStyleType: 'disc', listStylePosition: 'inside' }}>
                {renderDescription}
            </List>
        </Grid>
    );
};
